module.exports = __webpack_public_path__ + "static/media/image-card-2.8a7fee80.png";